import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=1b24b1ce&scoped=true&lang=pug&"
import script from "./ButtonLink.vue?vue&type=script&lang=ts&"
export * from "./ButtonLink.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&id=1b24b1ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b24b1ce",
  null
  
)

export default component.exports